import { MessageMultiple01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const MessagesSquare = /* @__PURE__ */ createIcon(MessageMultiple01Icon, 'MessagesSquare');
